export default __webpack_public_path__ + "static/Tasmaew Insuranace_logo-7907a36eafe5e7d61ad7bf099cce1a38.png";